import { render, staticRenderFns } from "./edit-bulk-intermediate-recipient.vue?vue&type=template&id=84bd1c4a&scoped=true&"
import script from "./edit-bulk-intermediate-recipient.vue?vue&type=script&lang=js&"
export * from "./edit-bulk-intermediate-recipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bd1c4a",
  null
  
)

export default component.exports